import { PaletteMode } from '@mui/material';
import { ChronosphereColorPalette, green, unityGreen } from '../colors';
import { GetThemeOptions } from '../../theme';

export const primaryColor = (mode: PaletteMode, opts: GetThemeOptions): ChronosphereColorPalette => {
  if (opts.panwRebrandStubYear) {
    return mode === 'light'
      ? {
          main: unityGreen[600],
          highContrast: unityGreen[800],
          lowContrast: unityGreen[100],
        }
      : {
          main: unityGreen[400],
          highContrast: unityGreen[300],
          lowContrast: unityGreen[700],
        };
  }

  return mode === 'light'
    ? {
        main: green[600],
        highContrast: green[800],
        lowContrast: green[150],
      }
    : {
        main: green[500],
        highContrast: green[300],
        lowContrast: green[700],
      };
};
